import { reactive } from 'vue';

const state = reactive({ rules: new Set() });

export const can = (action, subject) => {
  if (Array.isArray(action)) {
    return action.some(a => state.rules.has(`${a}:${subject}`));
  }
  return state.rules.has(`${action}:${subject}`);
};

export const setAbility = (permissions) => {
  const next = new Set();
  permissions.forEach(({ subject, actions }) => {
    actions.forEach(action => next.add(`${action}:${subject}`));
  });
  state.rules = next;
};

export const revokeAbility = () => {
  state.rules = new Set();
};

export default { can };
